export const IMPERSONATION_QUERY_PARAM = "imp";

export const IMPERSONATION_STORAGE_KEY = "admin_impersonation_context";
